// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","basket":"header_basket__kk1gO","log":"header_log__ssd1V","logo_name":"header_logo_name__vc9os","link":"header_link__xp8Z0"};